import React from 'react'

import { COMPANY_PROFILE_TAB } from '@/components/misc/CompanyProfile/constants'
import ExternalLink from '@/components/misc/ExternalLink'
import { COMPANY_PROFILE_IDENTIFIER_TYPE } from '@/lib/constants'
import { ROUTES } from '@/lib/routes'
import { ReferralsImportItem } from '@/redux/slices/referralsImportBase'
import { CompanyEntity } from '@/types/entities'

interface Props {
  importItem: Pick<ReferralsImportItem, 'sourceClientEmail'> & {
    importingCompany: null | Pick<CompanyEntity, 'id'>
    fromCompany: null | Pick<CompanyEntity, 'id'>
    toCompany: null | Pick<CompanyEntity, 'id'>
  }
  field?: string
  message: string
}

const ImportErrorMessage: React.FC<Props> = ({
  importItem,
  field = '',
  message,
}) => {
  let otherCompanyId: number | undefined = undefined
  if (
    importItem.importingCompany &&
    importItem.fromCompany &&
    importItem.toCompany
  ) {
    otherCompanyId =
      importItem.importingCompany.id == importItem.fromCompany.id
        ? importItem.toCompany.id
        : importItem.fromCompany.id
  }
  let fieldPart = <></>
  if (field === 'email') {
    fieldPart = (
      <>
        <span className="font-semibold">client's email address</span>:{' '}
      </>
    )
    message =
      message.substring(0, message.length - 1) +
      ` ("${importItem.sourceClientEmail}").`
  } else if (field != '') {
    fieldPart = (
      <>
        <span className="font-semibold">{field}</span>:{' '}
      </>
    )
  }

  if (message.includes('create a commercial agreement') && otherCompanyId) {
    // Replace 'create a commercial agreement' with a link to /professional-network/relationships?...&tab=commercialAgreements page
    const parts = message.split('create a commercial agreement')

    return (
      <>
        {fieldPart}
        {parts[0]}
        <ExternalLink
          href={ROUTES.professionalNetworkRelationships({
            searchParams: {
              identifier: String(otherCompanyId),
              identifierType: COMPANY_PROFILE_IDENTIFIER_TYPE.companyId,
              profileTab: COMPANY_PROFILE_TAB.commercialAgreements,
            },
          })}
          className="text-destructive underline"
        >
          create a commercial agreement
        </ExternalLink>
        {parts[1]}
      </>
    )
  }
  return (
    <>
      {fieldPart}
      {message}
    </>
  )
}

export default ImportErrorMessage
